import { useEffect, useState } from 'react';

const PropertyDetails = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if user is on Android
    const isAndroid = /Android/i.test(navigator.userAgent);
    
    // Add a small delay for a smooth slide-up effect
    if (isAndroid) {
      setTimeout(() => setShowBanner(true), 500);
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => setShowBanner(false), 300); // Wait for animation to finish
  };

  const openPlayStore = () => {
    window.location.href = "https://play.google.com/store/apps/details?id=in.metronavixhub.android";
  };

  return (
    <div style={styles.pageContainer}>
      
      {/* ��� Elegant Mobile App Banner */}
      {showBanner && (
        <div style={{
          ...styles.bannerContainer,
          ...(isClosing ? styles.slideDown : styles.slideUp)
        }}>
          {/* Close Button */}
          <button onClick={handleClose} style={styles.closeButton}>×</button>

          {/* App Icon (Placeholder) */}
          <div style={styles.iconContainer}>
            <span style={{ fontSize: '20px' }}>���</span> 
            {/* Replace the span above with your <img src="/logo.png" /> */}
          </div>

          {/* Text Content */}
          <div style={styles.textContainer}>
            <div style={styles.title}>MetroNavix</div>
            <div style={styles.subtitle}>View better in the app</div>
          </div>

          {/* Install Button */}
          <button onClick={openPlayStore} style={styles.installButton}>
            OPEN
          </button>
        </div>
      )}

      {/* Your Existing Page Content */}
      <div style={styles.content}>
        <h1>Property Details</h1>
        <p>Your beautiful property content goes here...</p>
        <div style={{ height: '200vh' }}>Scroll to test the floating banner...</div>
      </div>

    </div>
  );
};

// ��� Styles Object (Matches your Flutter App Theme)
const styles: { [key: string]: React.CSSProperties } = {
  pageContainer: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    position: 'relative',
    minHeight: '100vh',
  },
  content: {
    padding: '20px',
  },
  bannerContainer: {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '90%',
    maxWidth: '400px',
    backgroundColor: '#1A1C20', // Dark Surface Color from your app_theme.dart
    color: 'white',
    borderRadius: '16px',
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)', // Elegant shadow
    zIndex: 1000,
    transition: 'transform 0.3s ease-in-out, opacity 0.3s',
  },
  slideUp: {
    animation: 'slideUp 0.4s ease-out forwards',
  },
  slideDown: {
    opacity: 0,
    transform: 'translate(-50%, 20px)',
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: '#888',
    fontSize: '24px',
    lineHeight: '1',
    marginRight: '12px',
    cursor: 'pointer',
    padding: '0 4px',
  },
  iconContainer: {
    width: '40px',
    height: '40px',
    borderRadius: '8px',
    backgroundColor: '#333',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    flexShrink: 0,
  },
  textContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '2px',
  },
  subtitle: {
    fontSize: '12px',
    color: '#aaa', // Grey caption text
  },
  installButton: {
    backgroundColor: '#2196F3', // Flutter Primary Blue (Seed Color)
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '20px', // Pill shape
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
};

export default PropertyDetails;
